module.exports = __webpack_public_path__ + "img/audio-playing.164a8181.gif";